import { ProjectDetailLayout } from "@/components/projects/project-detail-layout.tsx";
import { m } from "@/paraglide/messages.js";
import { projectQueryOptions } from "@/services/projects-service.ts";
import { createEntityErrorBoundary } from "@/utils/entity-error-boundary.tsx";
import { z } from "zod";
import { createFileRoute } from "@tanstack/react-router";
import { ArtifactProvider } from "@/components/artifacts/artifact-provider.tsx";
import { pageTitle } from "@/utils/page-title.ts";
import { RoutePending } from "@/components/custom/route-pending.tsx";

export const Route = createFileRoute(
	"/_authenticated/dashboard/projects/$projectId",
)({
	loader: async ({ params, context: { queryClient } }) => {
		// Validate here (not in params.parse) so a malformed id throws inside the
		// loader, where the route's errorComponent catches it — param-parse throws
		// happen during matching and escape to the global boundary instead.
		z.uuid().parse(params.projectId);
		const project = await queryClient.ensureQueryData(
			projectQueryOptions(params.projectId),
		);

		return { project };
	},
	errorComponent: createEntityErrorBoundary({
		title: m.project_not_found_title,
		description: m.project_not_found_description,
		backLabel: m.project_not_found_back,
		backTo: "/dashboard/projects",
	}),
	head: ({ loaderData }) => ({
		meta: [
			{
				title: pageTitle(loaderData?.project.name ?? m.project_detail_title()),
			},
		],
	}),
	component: RouteComponent,
	pendingComponent: RoutePending,
});

function RouteComponent() {
	const { projectId } = Route.useParams();
	return (
		<ArtifactProvider spaceId={projectId}>
			<ProjectDetailLayout />
		</ArtifactProvider>
	);
}
